import { CSVQuestionRow, CURSORS_STORAGE_KEY, Question } from '@src/app-models';

/**
 * Retourne le prochain index de question à afficher pour un principe donné, en mode circulaire, et le persiste.
 * @param principe le principe normalisé
 * @param total le nombre total de questions pour ce principe
 * @returns l'index à utiliser
 */
export function getNextQuestionIndex(principe: string, total: number): number {
  if (total <= 0) {
    return 0;
  }
  const cursors = readPrincipleCursors();
  const lastIndex = typeof cursors[principe] === 'number' ? cursors[principe] : -1;
  let nextIndex = lastIndex + 1;
  if (nextIndex >= total || nextIndex < 0) {
    nextIndex = 0;
  }
  cursors[principe] = nextIndex;
  writePrincipleCursors(cursors);
  return nextIndex;
}

export const normalize = (s?: string) => (s ?? '').trim().toLowerCase();

export function readPrincipleCursors(): Record<string, number> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(CURSORS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, number>;
    }
  } catch {
    console.error('Error reading principle cursors from localStorage');
  }
  return {};
}

export function writePrincipleCursors(obj: Record<string, number>): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(CURSORS_STORAGE_KEY, JSON.stringify(obj));
  } catch {
    console.error('Error writing principle cursors to localStorage');
  }
}

export function mapCsvRowToQuestion(row: CSVQuestionRow): Question {
  const clean = (v?: string) => (v ?? '').trim();

  const choices = [clean(row['Réponse A']), clean(row['Réponse B']), clean(row['Réponse C']), clean(row['Réponse D'])].filter(v => v.length > 0);

  let answer = null;
  const answerABCD = clean(row['Bonne réponse']);
  if (answerABCD === 'A') answer = clean(row['Réponse A']);
  if (answerABCD === 'B') answer = clean(row['Réponse B']);
  if (answerABCD === 'C') answer = clean(row['Réponse C']);
  if (answerABCD === 'D') answer = clean(row['Réponse D']);

  return {
    image: 'assets/images/' + clean(row['Cle']) + '/quest.png',
    principe: clean(row['Principe']).toLowerCase(),
    text: clean(row['Question']),
    choices,
    answer,
    comment: clean(row['Commentaire']),
  };
}
